<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card appeals-create-card">
        <md-card-content class="mobile-content">
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100 md-layout-item-field">
              <div class="table-title md-theme-block-head-color appeals-create-card__cat-title">
                {{ categoryName ? categoryName : 'СВОБОДНАЯ ФОРМА' }}
              </div>
            </div>

            <div class="md-layout-item md-size-100 md-layout-item-field">
              <md-field maxlength="5">
                <label :class="{'custom-valid-label': appeal.description && appeal.description.length > 0}">
                  Что у вас случилось ?
                </label>
                <md-textarea v-model="appeal.description" />
                <md-icon class="attach-icon"
                         @click.native="$refs.filesAppeal.click()">attach_file</md-icon>
              </md-field>
            </div>

            <template v-if="!$checkMobile()" class="hidden-sm">
              <div class="md-layout-item md-small-size-100 md-size-100 md-layout-item-field">
                <div class="table-title md-theme-block-head-color">
                  ВАШИ ДАННЫЕ
                </div>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-100 md-layout-item-field text-main-black">
                <div class="text-grey-1">{{ addressLabel }}</div>
                <div class="text-grey-1">{{ PALabel }}</div>
                <div class="text-grey-1">+{{ getUsername }}</div>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33 md-layout-item-field">
                <md-field :class="{'md-valid': appeal.applicant.lastName && appeal.applicant.lastName.length > 1}">
                  <label>Фамилия*</label>
                  <md-input v-model="appeal.applicant.lastName"
                            type="text"
                            :clearSelectOnDisabled="false"
                  />
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33 md-layout-item-field">
                <md-field :class="{'md-valid': appeal.applicant.firstName && appeal.applicant.firstName.length > 1}">
                  <label>Имя*</label>
                  <md-input v-model="appeal.applicant.firstName"
                            type="text"
                            :clearSelectOnDisabled="false"
                  />
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33 md-layout-item-field">
                <md-field :class="{'md-valid': appeal.applicant.patronymicName && appeal.applicant.patronymicName.length > 1}">
                  <label>Отчество</label>
                  <md-input v-model="appeal.applicant.patronymicName"
                            type="text"
                            :clearSelectOnDisabled="false"
                  />
                </md-field>
              </div>

              <input
                v-show="false"
                type="file"
                id="filesAppeal"
                @change="selectFiles()"
                multiple
                ref="filesAppeal"
                :disabled="loaderPreparedFiles"
              />
              <div class="md-layout-item md-small-size-100 md-size-100 md-layout-item-field"
                   v-if="fdata.length">
                <div class="attachments-wrap">
                  <div
                    v-for="(fileAttach, idx) in fdata"
                    :key="`file_attach_${idx}`"
                    v-if="fileAttach.isValid === true"
                    class="thumb-link"
                  >
                    <image-thumbnail
                      v-if="fileAttach.base64Thumb"
                      preview
                      showDeleteBtn
                      :pic="fileAttach.base64Thumb"
                      @onDelete="removeSelectedFile(idx)" />
                    <file-thumbnail
                      v-else
                      preview
                      showDeleteBtn
                      :fileName="fileAttach.name"
                      @onDelete="removeSelectedFile(idx)" />
                  </div>
                </div>
              </div>

              <div class="md-layout-item md-small-size-100 md-layout-item-field text-align-right">
                <md-button class="md-blue create-btn"
                           @click="createAppeal"
                           :disabled="loader"
                >
                  <circle-loader v-if="loader" :diameter="20" />
                  <span v-else>Отправить</span>

                </md-button>
              </div>
            </template>
          </div>
        </md-card-content>
      </md-card>

      <template v-if="$checkMobile()">
        <h5 class="text-main-black text-align-center" style="max-width: 785px;">
          ВАШИ ДАННЫЕ
        </h5>
        <md-card class="mobile-card appeals-create-card">
          <md-card-content class="mobile-content">
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-100 md-layout-item-field text-main-black">
                <div class="text-grey-1">{{ addressLabel }}</div>
                <div class="text-grey-1">{{ PALabel }}</div>
                <div class="text-grey-1">+{{ getUsername }}</div>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33 md-layout-item-field">
                <md-field :class="{'md-valid': appeal.applicant.lastName && appeal.applicant.lastName.length > 1}">
                  <label>Фамилия*</label>
                  <md-input v-model="appeal.applicant.lastName"
                            type="text"
                            :clearSelectOnDisabled="false"
                  />
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33 md-layout-item-field">
                <md-field :class="{'md-valid': appeal.applicant.firstName && appeal.applicant.firstName.length > 1}">
                  <label>Имя*</label>
                  <md-input v-model="appeal.applicant.firstName"
                            type="text"
                            :clearSelectOnDisabled="false"
                  />
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33 md-layout-item-field">
                <md-field :class="{'md-valid': appeal.applicant.patronymicName && appeal.applicant.patronymicName.length > 1}">
                  <label>Отчество</label>
                  <md-input v-model="appeal.applicant.patronymicName"
                            type="text"
                            :clearSelectOnDisabled="false"
                  />
                </md-field>
              </div>

              <input
                v-show="false"
                type="file"
                id="filesAppeal"
                @change="selectFiles()"
                multiple
                ref="filesAppeal"
                :disabled="loaderPreparedFiles"
              />
              <div class="md-layout-item md-small-size-100 md-size-100 md-layout-item-field"
                   v-if="fdata.length">
                <div class="attachments-wrap">
                  <div
                    v-for="(fileAttach, idx) in fdata"
                    :key="`file_attach_${idx}`"
                    v-if="fileAttach.isValid === true"
                    class="thumb-link"
                  >
                    <image-thumbnail
                      v-if="fileAttach.base64Thumb"
                      preview
                      showDeleteBtn
                      :pic="fileAttach.base64Thumb"
                      @onDelete="removeSelectedFile(idx)" />
                    <file-thumbnail
                      v-else
                      preview
                      showDeleteBtn
                      :fileName="fileAttach.name"
                      @onDelete="removeSelectedFile(idx)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="md-layout-item md-small-size-100 md-layout-item-field text-align-center">
              <md-button class="md-blue create-btn"
                         @click="createAppeal"
                         :disabled="loader"
              >
                <circle-loader v-if="loader" :diameter="20" />
                <span v-else>Отправить</span>

              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </template>

      <appeals-category-modal
        :showDialog="categoriesModal"
        @onSelect="appeal.category = $event"
        @closeDialog="categoriesModal = false"
        @onFreeFormSelected="appeal.category = null"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import to from "await-to-js";
import { mapGetters } from "vuex";
import CircleLoader from '@/components/Custom/CircleLoader';
import AppealsCategoryModal from '@/apps/appeals/components/AppealsCategoryModal';
import ImageThumbnail from '@/components/Custom/ImageThumbnail';
import FileThumbnail from '@/components/Custom/FileThumbnail';
import { sortByAttachOrder, compressSingleImage } from '@/services';


export default {
  name: "AppealsCreate",
  components: {
    CircleLoader,
    AppealsCategoryModal,
    ImageThumbnail,
    FileThumbnail,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      categoriesModal: false,
      appeal: {
        category: null,
        description: null,
        applicant: {
          email: '',
          firstName: null,
          lastName: null,
          patronymicName: null,
          username: null,
        },
      },
      fdata: [],
      order: 1,
      loaderPreparedFiles: false,
      loader: false
    }
  },
  created() {
    if (this.categories && this.categories.length > 0) {
      this.categoriesModal = true;
    }
  },
  computed: {
    ...mapGetters([
      'categories',
      'getPersonalAccountInfo',
      'getUsername'
    ]),

    addressLabel() {
      if (this.getPersonalAccountInfo) {
        const { thoroughfare, premise, objectname, number} = this.getPersonalAccountInfo.apartment;
        return `${thoroughfare} ${premise}, ${objectname} ${number}`;
      }
      return '';
    },

    PALabel() {
      if (this.getPersonalAccountInfo) {
        const { number } = this.getPersonalAccountInfo.personalAccount;
        return `ЛС ${number}`;
      }
      return '';
    },

    categoryName() {
      return this.appeal.category ? this.appeal.category.fullName : null
    },
  },
  methods: {
    sortByAttachOrder,

    async createAppeal() {
      const { category, applicant, description } = this.appeal;
      if (!applicant.firstName || !applicant.lastName) {
        this.$notifyDanger('Укажите ваше имя и фамилию');
        return;
      }

      if (!description) {
        this.$notifyDanger('Вы не указали описание');
        return;
      }

      const params = {
        data: {
          applicant: { ...applicant, username: this.getUsername },
          description,
        },
        username: this.getUsername
      }
      if (category) {
        params.categoryId = category.id;
      }

      this.loader = true;
      const [err, resp] = await to(api.appeals.create(params));


      if (err) {
        this.$notifyDanger('Ошибка')
        return;
      }

      if (this.fdata.length > 0) {
        const [errUpload] = await to(this.uploadFiles(resp.data.id));

        if (errUpload) {
          this.$notifyDanger('Ошибка Загрузки файлов')
          return;
        }
      }


      this.loader = false;
      this.$router.push({ name: 'AppealsDetail', params: { id: resp.data.id }});
    },

    uploadFiles(appealId) {
      const filePicker = this.$refs.filesAppeal;
      const compressedFiles = this.fdata;
      const countFiles = this.fdata.length;
      const sentFiles = [];

      for (let i=0; i < countFiles; i++) {
        if (compressedFiles[i].isValid === true) {
          const file = compressedFiles[i];
          let formData = new FormData();
          formData.append('appeal', appealId);
          formData.append('file', file);
          formData.append('order', this.order);
          formData.append('forLastEvent', false);
          sentFiles.push(api.appeals.uploadFile({ data: formData, username: this.getUsername }));
          this.order = this.order + 1;
        }
      }

      return Promise.all(sentFiles).then(() => {
        filePicker.value = null;
        this.fdata = [];
        this.order = 1;

        return Promise.resolve();
      })
    },

    removeSelectedFile(index){
      const $el = this.$refs.filesAppeal;

      if (this.fdata.length === 1) {
        $el.value = '';
      }
      this.fdata.splice(index, 1);
    },

    selectFiles() {
      const filePicker = this.$refs.filesAppeal;
      const countFiles = filePicker.files.length;

      if (!countFiles) {
        return;
      }

      const files = [ ...filePicker.files ];

      for (let i = 0; i < countFiles; i++) {
        const fileReader = new FileReader();
        const file = files[i];
        const fileType = file.type.split('/', 1).join();

        if (i === 0) {
          this.loaderPreparedFiles = true;
        }

        fileReader.onloadstart = async () => {
          if (fileType === 'image') {
            const compressedFile = await compressSingleImage(file);
            this.fdata.push(compressedFile);
            if (i === countFiles -1) {
              this.loaderPreparedFiles = false;
            }
          } else {
            file.isValid = true;
            this.fdata.push(file);
            this.loaderPreparedFiles = false;
          }
        };
        fileReader.readAsDataURL(filePicker.files[i]);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.appeals-create-card {
  .md-card-content {
    padding: 25px 20px;
  }
  &__cat-title {
    @media (max-width: 768px) {
      margin-top: 10px;
    }
  }
}
.appeals-create-wrapper {
  padding: 0 10px;
}
.create-btn {
  min-width: 163px;
  height: 41px;
}
.load-wrapper {
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
